module.exports = __webpack_public_path__ + "img/logo.cf055c84.png";